import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { AntdAlert as Alert } from '@yuhuinc/ui-library/';

const FormError = ({ errors }) => {
  if (isEmpty(errors)) return null;

  let message = Object.values(errors).map((value) => <div>{value}</div>);
  return <Alert type="error" message={message} closable={false} showIcon />;
};

export { FormError };
